// TopBar (TopNav)

import React from "react";
import { useUser } from "../UserContext";
import { Button, Drawer, Typography } from "@mui/material";
import SettingsIcon from '@mui/icons-material/Settings';
import GButton from "./GButton"
import GIconButton from "./GIconButton"

export default function TopBar({ isLoggedIn, onNavigate, onLogout, showNavMenu }) {
  const { user, setUser, isMobile } = useUser();

  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem('jwt');
    localStorage.removeItem('user');
    onLogout();
    onNavigate('login');
  };

  const openSettings = () => {
    onNavigate('settings');
  }

  return (

    <div>
      <div style={{
        height: '80px',
        width: showNavMenu ? 'calc(100% - 200px)' : '100%',
        left: showNavMenu ? '200px' : '0',
        backgroundColor: isLoggedIn ? '#E9ECEF' : '#0A2647',
        color: isLoggedIn ? '#144272' : '#FFFFFF',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: ' 0 20px',
        borderBottom: '3px solid #144272',
        position: 'fixed',
        top: 0,
        zIndex: 2000,
        boxSizing: 'border-box'
      }}
      >
        {/*  no loggin  */}
        {!isLoggedIn && (
          <>


            <div />

            {/* derecha: botones públicos */}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px'
              }}
            >
              <GButton variant="secondary" onClick={() => onNavigate('home')}>Inicio</GButton>
              <GButton variant="secondary" onClick={() => onNavigate('about')}>Nosotros</GButton>
              <GButton variant="secondary" onClick={() => onNavigate('contact')}>Contacto</GButton>
              <GButton variant="secondary" onClick={() => onNavigate('login')}>Iniciar Sesión</GButton>
            </div>
          </>
        )}


        {/* logeado */}
        {isLoggedIn && (
          <>
            <div style={{ flex: 1 }} />

            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                flex: '0 0 auto',
                overflow: 'hidden'
              }}
            >
              <span
                style={{
                  whiteSpace: 'nowrap',
                  maxWidth: '120px',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis'
                }}
              >
                Hola, {user.person?.firstname} {user.person?.lastnameFirst}
              </span>

              <GIconButton onClick={openSettings} tooltip="ajustes">
                <SettingsIcon />
              </GIconButton>

              <GButton 
                variant="secondary" 
                onClick={handleLogout}
                >
                Cerrar Sesión
              </GButton>

            </div>
          </>
        )}
      </div>
    </div>
  );
}
